import styled from "@emotion/styled";
import { useHead } from "@unhead/react";

import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { PublicFooter } from "@/components/nav/PublicFooter";
import { PublicNav } from "@/components/nav/PublicNav";
import { MainHeroBottom } from "@/components/pieces/marketing/MainHeroBottom";
import { OPACITY_TRANSITION, SITE_NAME } from "@/css/constants";

import { Catalyst } from "./Catalyst";
import { FounderLetter } from "./FounderLetter";
import { MainHero } from "./MainHero";
import { Principles } from "./Principles";

export function About() {
  useHead({
    bodyAttrs: { class: "public-site" },
  });

  return (
    <>
      <SEOHead
        title={`About ${SITE_NAME}`}
        description="At Exec, we recognize that people are the beating heart of every
        organization. We provide the essential solutions that enable talent
        development and a thriving company culture. By opening doors to
        personal growth and lasting improvements, we empower leaders and
        their teams to go further and grow faster."
        canonicalPath="/about-us"
        image="https://placement-pub.s3.us-east-2.amazonaws.com/about-meta.jpg"
      />
      <PublicNav />
      <StyledContainer className="content-page">
        <MainHero />
        <Catalyst />
        <Principles />
        <FounderLetter />
        <MainHeroBottom
          title="Ready to scale excellence in your organization?"
          subtitle="Schedule a demo to learn how Exec can help."
          ctaLink="/demo"
          ctaText="Schedule Demo"
          headerSize={[36, 48, 60]}
        />
      </StyledContainer>
      <PublicFooter />
    </>
  );
}

const StyledContainer = styled.div`
  transition: ${OPACITY_TRANSITION};
  .story-title {
    font-size: 30px;
    font-weight: 300;
    margin-top: 0;
    margin-bottom: 8px;
    line-height: 1.42;
  }
  .story-img-container {
    position: relative;
    .story-img-background {
      position: absolute;
      z-index: -5;
      bottom: -45px;
      left: 0;
      right: 0;
    }
  }
  .investors-container {
    background-color: #f5f8ff;
  }
  .placement-office {
    width: 100%;
    border-radius: 8px;
  }
`;
